<template>
  <layout-side-menu-content>
    <settings-caption>
      APIテスト
    </settings-caption>

    <form-component />
    <list />
  </layout-side-menu-content>
</template>

<script>
import LayoutSideMenuContent from '@/lib/Layout/SideMenuContent'
import SettingsCaption from '@/components/Settings/Caption'
import FormComponent from './FormComponent/index'
import List from './List'

export default {
  components: {
    LayoutSideMenuContent,
    SettingsCaption,
    FormComponent,
    List
  }
}
</script>
